import { render } from "./MatchTabs.vue?vue&type=template&id=1c7a8099&scoped=true&ts=true"
import script from "./MatchTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchTabs.vue?vue&type=script&setup=true&lang=ts"

import "./MatchTabs.vue?vue&type=style&index=0&id=1c7a8099&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7a8099"],['__file',"src/components/match/MatchTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c7a8099"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c7a8099', __exports__)) {
    console.log('reload')
    api.reload('1c7a8099', __exports__)
  }
  
  module.hot.accept("./MatchTabs.vue?vue&type=template&id=1c7a8099&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('1c7a8099', render)
  })

}


export default __exports__